import React, { Component, Fragment } from 'react';
import { withRouter } from '../../util/withRouter';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Hidden from '../Hidden';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { CalendarIcon, ContactsIcon, PayableIcon, SearchIcon, StarIcon, TransfersIcon } from '../IconIndex';
import { clearToken, getUser } from '../../util/sessions';
import cx from 'classnames';
import EditContactModal from '../EditContactModal';
import NotificationsPopover from '../../page/workQueue/notifications/NotificationPopover';
import CreateEditTaskModal from '../../page/workQueue/taskModal/CreateEditTaskModal';
import { createOrUpdateTaskFunc } from '../../page/workQueue/components/GetSaveTasks';
import AppointmentPopover from '../../page/calendar/AppointmentPopover';
import GatedComponent from '../GatedComponent';
import { resetClient } from '../../apollo';
import { setSnackbarMessage } from '../../context/SnackbarMessage';
import TaskModal from '../../page/workQueue2/Modals/TaskModal';
import Fab from '@mui/material/Fab';
import { joinDefined } from '../../util/strings';
import { CapsuleLegend } from '../form/Legend';
import { compose } from '../../reactApolloCompat';
import { getOffices } from '../../environment';
import { EditAppointmentConsumer } from '../../context/EditAppointment';
import { ListSubheader } from '@mui/material';
import NewTransferModal from '../../page/transfers/NewTransferModal';
import { recolour } from '../../Theme';

class HeaderActions extends Component {
    state = {
        addressBookModalOpen: false,
        appointmentModalOpen: false,
        newTransferModalOpen: false,
        showCreateEditTaskModal: false,
        showNewTaskModal: false,
        userMenuAnchor: undefined,
        addMenuAnchor: undefined
    };

    onToggleUserMenu = (e = {}) => {
        this.setState({ userMenuAnchor: this.state.userMenuAnchor ? undefined : e.currentTarget });
    };

    onToggleAddMenu = (e = {}) => {
        this.setState({ addMenuAnchor: this.state.addMenuAnchor ? undefined : e.currentTarget });
    };

    onClickProfile = () => {
        this.onToggleUserMenu();
        this.props.history.push('/account');
    };

    onClickLogout = () => {
        this.onToggleUserMenu();
        clearToken();
        resetClient();
        setSnackbarMessage('You have signed out.', true);
    };

    onCloseNewContact = () => {
        this.setState({ addressBookModalOpen: false });
    };

    render() {
        const { classes } = this.props;
        const { addressBookModalOpen } = this.state;
        return (
            <GatedComponent isEnabledCode={'OBJ_EDIT_ALL'}>
                {(canAccess, data) => {
                    const { readCurrentUser } = data;
                    const allOffices = getOffices();
                    const myOffice =
                        readCurrentUser.MyLastOfficeID && allOffices.find(e => e.ID === readCurrentUser.MyLastOfficeID);

                    return (
                        <div className={classes.headerBar}>
                            {!!canAccess && this.renderSearchButton()}
                            {!!canAccess && this.renderNotificationsButton()}
                            {!!canAccess && this.renderAddButton(myOffice)}
                            {this.renderUserButton(readCurrentUser, myOffice)}
                            {this.renderUserMenu(readCurrentUser, canAccess)}
                            {!!canAccess && this.renderAddMenu(myOffice)}
                            {!!canAccess && (
                                <Fragment>
                                    <EditContactModal open={!!addressBookModalOpen} onClose={this.onCloseNewContact} />
                                    <CreateEditTaskModal
                                        onClose={() => this.setState({ showCreateEditTaskModal: false })}
                                        open={this.state.showCreateEditTaskModal}
                                        onSubmit={task => createOrUpdateTaskFunc(task, false)}
                                        user={getUser()}
                                    />
                                    <TaskModal
                                        open={this.state.showNewTaskModal}
                                        onClose={() => this.setState({ showNewTaskModal: false })}
                                    />
                                    <NewTransferModal
                                        open={!!this.state.newTransferModalOpen}
                                        onClose={() => this.setState({ newTransferModalOpen: false })}
                                    />
                                    <EditAppointmentConsumer>
                                        {consumer => (
                                            <AppointmentPopover
                                                open={!!this.state.appointmentModalOpen}
                                                onClose={() =>
                                                    this.setState({
                                                        appointmentModalOpen: false,
                                                        editAppointmentId: null
                                                    })
                                                }
                                                defaults={{ Office: myOffice ? myOffice.LegacyKey : null }}
                                                allowLocation={true}
                                                allowRecurring={true}
                                                onMutate={consumer.onCalendarRefresh}
                                            />
                                        )}
                                    </EditAppointmentConsumer>
                                </Fragment>
                            )}
                        </div>
                    );
                }}
            </GatedComponent>
        );
    }

    renderAddButton(office) {
        const { classes, theme } = this.props;
        const fgColour = office ? theme.palette.contentForeground[office.RegistrantSuffix] : '#35327c';
        const bgColour = office ? theme.palette.contentBackground[office.RegistrantSuffix] : '#DCE4F0';
        const hoverBG = recolour(fgColour, '#000000', 0.25); // darker
        const fabSX = { bgcolor: fgColour, color: 'white', '&:hover': { bgcolor: hoverBG } };
        return (
            <Fragment>
                <Hidden smDown>
                    <CapsuleLegend
                        onClick={this.onToggleAddMenu}
                        className={classes.capsuleLegend}
                        text={
                            <span>
                                <span style={{ margin: '0 6px' }}>
                                    <Hidden smDown> Add New </Hidden>
                                </span>
                                <Fab
                                    title={'Add New'}
                                    sx={fabSX}
                                    aria-label="add new"
                                    className={cx(classes.addButtonDesktop, classes.marginLeft)}
                                    onClick={this.onToggleAddMenu}
                                >
                                    <Icon>add</Icon>
                                    <Icon className={classes.userArrow}>keyboard_arrow_down</Icon>
                                </Fab>
                            </span>
                        }
                        foreground={fgColour}
                        background={bgColour}
                    />
                </Hidden>
                <Hidden smUp>
                    <Fab sx={fabSX} className={classes.addButtonMobile} onClick={this.onToggleAddMenu}>
                        <Icon>add</Icon>
                        <Icon className={classes.userArrow}>keyboard_arrow_down</Icon>
                    </Fab>
                </Hidden>
            </Fragment>
        );
    }

    renderNotificationsButton() {
        return <NotificationsPopover />;
    }

    renderUserButton(readCurrentUser, office) {
        const { classes, theme } = this.props;
        const profileName =
            joinDefined(
                [
                    readCurrentUser.FirstName ? readCurrentUser.FirstName.charAt(0) : '',
                    readCurrentUser.Surname ? readCurrentUser.Surname.charAt(0) : ''
                ],
                ''
            ) || '?';

        const fgColour = office ? theme.palette.contentForeground[office.RegistrantSuffix] : '#35327c';
        const bgColour = office ? theme.palette.contentBackground[office.RegistrantSuffix] : '#DCE4F0';
        const hoverBG = recolour(fgColour, '#000000', 0.25); // darker
        const fabSX = { bgcolor: fgColour, color: 'white', '&:hover': { bgcolor: hoverBG } };

        const renderButton = (
            <Fab
                title={joinDefined([readCurrentUser.FirstName, readCurrentUser.Surname], ' ')}
                sx={fabSX}
                aria-label="user settings"
                className={cx(classes.userButton, classes.marginLeft)}
                classes={{ label: classes.userButtonLabel }}
                onClick={this.onToggleUserMenu}
            >
                {profileName}
                <Icon className={classes.userArrow}>keyboard_arrow_down</Icon>
            </Fab>
        );

        if (office)
            return (
                <CapsuleLegend
                    onClick={this.onToggleUserMenu}
                    className={classes.capsuleLegend}
                    text={
                        <span>
                            <span style={{ margin: '0 6px' }}>
                                <Hidden smDown>{office && office.Title}</Hidden>
                                <Hidden smUp>{office && office.RegistrantSuffix}</Hidden>
                            </span>
                            {renderButton}
                        </span>
                    }
                    foreground={fgColour}
                    background={bgColour}
                />
            );
        return renderButton;
    }

    renderSearchButton() {
        const { classes, onToggleSearch } = this.props;
        return (
            <Hidden smUp>
                <div className={classes.searchWrapper}>
                    <IconButton className={classes.iconButton} onClick={onToggleSearch} size="large">
                        <SearchIcon className={classes.searchIcon} />
                    </IconButton>
                </div>
            </Hidden>
        );
    }

    renderUserMenu(readCurrentUser, canAccess) {
        const anchorEl = this.state.userMenuAnchor;

        return (
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={this.onToggleUserMenu}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <ListSubheader disableSticky style={{ color: 'black', lineHeight: 1, padding: '16px' }}>
                    <span>
                        {readCurrentUser.FirstName} {readCurrentUser.Surname}
                        <br />
                        <small style={{ opacity: 0.5 }}>{readCurrentUser.Email}</small>
                    </span>
                </ListSubheader>
                {!!canAccess && <MenuItem onClick={this.onClickProfile}>Account Settings</MenuItem>}
                <MenuItem onClick={this.onClickLogout}>Sign Out</MenuItem>
            </Menu>
        );
    }

    renderAddMenu(office) {
        const { classes, theme } = this.props;
        const fgColour = office ? theme.palette.contentForeground[office.RegistrantSuffix] : '#35327c';
        const bgColour = office ? theme.palette.contentBackground[office.RegistrantSuffix] : '#DCE4F0';
        const hoverSX = {
            '&:hover': { background: bgColour },
            '&:hover > svg': { background: fgColour, color: bgColour }
        };
        const anchorEl = this.state.addMenuAnchor;
        if (!office) {
            office = getOffices()[0];
        }
        return (
            <Menu
                id="add-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={this.onToggleAddMenu}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <GatedComponent showComponentCode={'FM_ACCESS_Enquiries_Create'}>
                    {() => {
                        return (
                            <MenuItem
                                className={cx('targetNewPage', classes.newIcon)}
                                sx={hoverSX}
                                onClick={() => {
                                    this.onToggleAddMenu();
                                    const newPath = `/quotes/enquiry/${office.RegistrantSuffix}/0`;
                                    let win = window.open(newPath, '_blank');
                                    win.focus();
                                }}
                            >
                                <PayableIcon />
                                Enquiry
                            </MenuItem>
                        );
                    }}
                </GatedComponent>

                <GatedComponent showComponentCode={'FM_ACCESS_Transfers_View'}>
                    {() => {
                        return (
                            <MenuItem
                                className={classes.newIcon}
                                sx={hoverSX}
                                onClick={() => {
                                    this.onToggleAddMenu();
                                    this.setState({ newTransferModalOpen: true });
                                }}
                            >
                                <TransfersIcon />
                                Transfer...
                            </MenuItem>
                        );
                    }}
                </GatedComponent>

                <GatedComponent showComponentCode={'FM_ACCESS_Contacts_Create'}>
                    {() => {
                        return (
                            <MenuItem
                                className={classes.newIcon}
                                sx={hoverSX}
                                onClick={() => {
                                    this.onToggleAddMenu();
                                    this.setState({ addressBookModalOpen: true });
                                }}
                            >
                                <ContactsIcon /> Supplier...
                            </MenuItem>
                        );
                    }}
                </GatedComponent>
                {1 === 2 && (
                    <GatedComponent showComponentCode={'FM_ACCESS_Tasks_Create'}>
                        {() => {
                            return (
                                <MenuItem
                                    onClick={() =>
                                        this.setState({ showCreateEditTaskModal: true }, () => this.onToggleAddMenu())
                                    }
                                >
                                    <StarIcon className={classes.newIcon} /> Task...
                                </MenuItem>
                            );
                        }}
                    </GatedComponent>
                )}
                <GatedComponent showComponentCode={'FM_ACCESS_Tasks_Create'}>
                    {() => {
                        return (
                            <MenuItem
                                className={classes.newIcon}
                                sx={hoverSX}
                                onClick={() => this.setState({ showNewTaskModal: true }, () => this.onToggleAddMenu())}
                            >
                                <StarIcon /> Task...
                            </MenuItem>
                        );
                    }}
                </GatedComponent>
                <GatedComponent showComponentCode={'FM_ACCESS_Appointments_Create'}>
                    {() => {
                        return (
                            <MenuItem
                                className={classes.newIcon}
                                sx={hoverSX}
                                onClick={() => {
                                    this.onToggleAddMenu();
                                    this.setState({ appointmentModalOpen: true });
                                }}
                            >
                                <CalendarIcon />
                                Appointment...
                            </MenuItem>
                        );
                    }}
                </GatedComponent>
            </Menu>
        );
    }
}

const styles = ({ spacing, breakpoints, palette }) => ({
    addButtonDesktop: {
        width: 40,
        height: 40,
        boxShadow: 'none',
        flex: '0 0 auto',
        fontSize: '1rem'
    },
    addButtonMobile: {
        width: 40,
        height: 40,
        boxShadow: 'none',
        flex: '0 0 auto'
    },
    iconButton: {
        flex: '0 0 auto'
    },
    userButton: {
        width: 40,
        height: 40,
        boxShadow: 'none',
        flex: '0 0 auto',
        fontSize: '1rem'
    },
    searchIcon: {
        fontSize: 24,
        color: palette.basePrimary['none']
    },
    userArrow: {
        position: 'absolute',
        color: palette.common.black,
        right: -12,
        bottom: -8,
        fontSize: 16
    },
    newIcon: {
        '& > svg': {
            fontSize: 32,
            marginRight: 16,
            transition: 'transform 0.2s ease-in-out, background 0.3s ease, color 0.3s ease',
            transform: 'translateZ(0)',
            imageRendering: 'crisp-edges',
            willChange: 'transform',
            vectorEffect: 'non-scaling-stroke',
            background: 'white',
            borderRadius: 99,
            padding: 6,
            overflow: 'visible'
        },
        '&:hover > svg': {
            animation: '$pulse 0.5s infinite alternate ease-in-out, $spin 0.2s ease-in-out 1s'
        }
    },
    '@keyframes pulse': {
        '0%': { transform: 'scale(1)' },
        '100%': { transform: 'scale(1.05)' }
    },
    '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    },
    capsuleLegend: {
        display: 'inline-block',
        position: 'relative',
        whiteSpace: 'pre',
        padding: 2,
        width: 'unset',
        cursor: 'pointer'
    },
    searchWrapper: {
        flexGrow: 1,
        paddingLeft: spacing(2),
        [breakpoints.down('sm')]: {
            paddingLeft: spacing(1)
        }
    },
    headerBar: {
        display: 'flex',
        columnGap: spacing(2),
        alignItems: 'center',
        justifyContent: 'end',
        [breakpoints.down('sm')]: {
            width: '100%',
            columnGap: spacing(1)
        }
    }
});

export default compose(withStyles(styles), withTheme, withRouter)(HeaderActions);
